import { memo } from 'react';
import ProductHighlightActions from './ProductHighlightActions';
import ProductHighlightHeader from './ProductHighlightHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ProductHighlight({
  objectId,
  onObjectCreate,
  hasScope,
  hasGate
}) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ProductHighlightActions, {
      objectId: objectId,
      onObjectCreate: onObjectCreate,
      hasScope: hasScope,
      hasGate: hasGate
    }), /*#__PURE__*/_jsx(ProductHighlightHeader, {
      objectId: objectId
    })]
  });
}
export default /*#__PURE__*/memo(ProductHighlight);